var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "comment_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 4.375h18.806v18.807H4.375V4.375Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#comment_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.845 20.716c.507 0 .986.192 1.493.396 3.103 1.435 6.774.783 9.165-1.608 3.155-3.157 3.155-8.292 0-11.448a8.038 8.038 0 0 0-5.722-2.368 8.038 8.038 0 0 0-5.724 2.37 8.131 8.131 0 0 0-1.621 9.134c.205.507.403 1 .403 1.513 0 .512-.176 1.027-.331 1.482-.128.375-.321.94-.197 1.064.122.126.69-.072 1.066-.2.45-.155.961-.332 1.468-.335Zm4.914 2.466a9.375 9.375 0 0 1-3.942-.865c-.371-.149-.718-.289-.968-.289-.287.002-.673.135-1.045.264-.765.262-1.717.59-2.421-.112-.702-.703-.378-1.652-.118-2.416.129-.376.261-.765.261-1.059 0-.241-.116-.55-.295-.993-1.639-3.54-.881-7.805 1.899-10.583a9.34 9.34 0 0 1 6.65-2.754 9.34 9.34 0 0 1 6.65 2.753c3.669 3.668 3.669 9.636 0 13.303a9.435 9.435 0 0 1-6.671 2.752Z",
    fill: "#767676"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.235 15.018a.878.878 0 0 1-.879-.875c0-.484.388-.875.87-.875h.009a.875.875 0 1 1 0 1.75ZM13.727 15.018a.878.878 0 0 1-.879-.875.87.87 0 0 1 .87-.875h.009a.875.875 0 1 1 0 1.75ZM10.218 15.018a.878.878 0 0 1-.878-.875c0-.484.387-.875.87-.875h.008a.875.875 0 1 1 0 1.75Z",
    fill: "#767676"
  })));
};
export default SvgComment;